import api from './api';

/**
 * Request a password-reset link. The API always responds generically (it won't
 * reveal whether the email has an account), so the UI shows the same message
 * regardless.
 */
export async function forgotPassword(email: string): Promise<{ message: string }> {
  const res = await api.post<{ message: string }>('/auth/forgot-password', { email });
  return res.data;
}

/**
 * Complete a password reset using the token from the emailed link.
 */
export async function resetPassword(token: string, newPassword: string): Promise<{ message: string }> {
  const res = await api.post<{ message: string }>('/auth/reset-password', { token, newPassword });
  return res.data;
}
